
  import { compactly, full, weekdayTime } from "@/js/local_time"

  export default {
    mounted() { this.render() },
    updated() { this.render() },
    render() {
      const at = new Date(this.el.dataset.at)
      if (isNaN(at)) return
      const { compact, weekly } = this.el.dataset
      const zone = this.el.dataset.zone === "true"
      if (weekly === "true") this.el.textContent = weekdayTime(at, zone)
      else if (compact === "true") this.el.textContent = compactly(at, zone)
      else this.el.textContent = full(at, zone)
    },
  }
